import { useApiPartnerUserList } from 'api/useApiPartnerUserList';
import { useZstdHeader } from 'header/header/useZstdHeader';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { IfPtnr, PtnrEntity } from 'models/partner-v2/IfPtnr';
import { usePopAiChatbot } from 'pages/popup/aichatbot/PopAiChatbot';
import { useEffect } from 'react';
import svcs from 'services';
import { paxios } from 'util/axiosprgs';
import { roleutil } from 'util/roleutil';
import { useZstdPartner } from 'zstd/useZstdPartner';

export const AppInit = () => {
  const loginInfo = useLoginInfo();
  const { setIsPartner, setPtnr, setDoneFetchPtnr } = useZstdHeader();

  const [, PopAiChatbot] = usePopAiChatbot();
  const { list: partnerUserList } = useApiPartnerUserList();
  const { setPartnerUserList } = useZstdPartner();
  useEffect(() => {
    setPartnerUserList(partnerUserList);
  }, [partnerUserList]);
  useEffect(() => {
    if (!loginInfo.userId) {
      setIsPartner(false);
      return;
    }
    roleutil.hasPartnerChecks(loginInfo.userId, svcs.svcLang.lang()).then((res) => {
      setIsPartner(res);
    });
  }, [loginInfo?.userId]);

  useEffect(() => {
    if (!loginInfo.userId) {
      setPtnr(new PtnrEntity());
      return;
    }
    paxios
      .get<IfPtnr>('/api/member/zdata/ptnr/ptnr/my-ptnr')
      .then((res) => {
        setPtnr(res.data ?? new PtnrEntity());
      })
      .catch((err) => {
        console.error('error get my ptnr', err);
        setPtnr(new PtnrEntity());
      })
      .finally(() => {
        setDoneFetchPtnr(true);
      });
  }, [loginInfo?.userId]);

  return (
    <>
      <PopAiChatbot />
    </>
  );
};
